import { print } from 'graphql';
import { gql } from 'graphql-tag';
import { v4 as uuidv4 } from 'uuid';

import { AdditionalFields } from '../common.types';
import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { TaskList, TaskListDocument } from './taskList.types';

export const taskListPullQueryBuilder = (document: TaskList) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query mobileAssetInspectionTaskListInfo(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime!
      $isLeadInspector: Boolean!
    ) {
      mobileAssetInspectionTaskListInfo(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
        isLeadInspector: $isLeadInspector
      ) {
        pkAssetInspectionTask
        fkSchedule
        fkAssetInspection
        fkInspectorLead
        fkInspectorField
        name
        taskDescription
        isActive
        isReviewedByLI
        isReviewedByFI
        commentInspectorLead
        commentInspectorField
        commentSiteCoordinator
        dateCreated
        dateModified
        site
        discipline
        modifiedBy
        createdBy
        pkUuId
        fkInspectionTaskStatusCategory
        attentionFlag
        isAssignedBack
        fieldInspectorUserId
        siteCoordinatorUserId
        recommendations
        dateCompleted
        leadInspectorName
        clerkId
        clerkName
        proxyInspector
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const taskListPushQueryBuilder = (doc: TaskListDocument[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation mobileFIAddOrUpdateInspection(
      $role: Int!
      $MobileFieldInspectorInspectionsInput: MobileFieldInspectorInspectionsInput
    ) {
      mobileFIAddOrUpdateInspection(
        role: $role
        mobileFieldInspectorInspections: $MobileFieldInspectorInspectionsInput
      ) {
        id
        pk_uuid
        status
      }
    }
  `);
  const { role, ...data } = document;
  const variables = {
    role: role ? role : 7,
    MobileFieldInspectorInspectionsInput: data,
  };
  return {
    query,
    variables,
  };
};

export const taskListPullModifier = (doc: TaskList) => {
  const result = {
    ...doc,
  };
  if (!result.pkUuId) {
    result.pkUuId = uuidv4();
  }
  return result;
};

export const taskListPushModifier = (doc: TaskListDocument) => {
  const obj: TaskListDocument &
    AdditionalFields & {
      isPerformedByFI: boolean;
      isBulkReAssignment: boolean;
    } = {
    ...doc,
    isPerformedByFI: false,
    isBulkReAssignment: false,
  };
  const blackListedProp = [
    '_attachments',
    '_rev',
    '_deleted',
    'name',
    'siteCoordinatorUserId',
    'fieldInspectorUserId',
    '_meta',
    'isDeleted',
    'leadInspectorName',
  ];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });
  return obj;
};
